import React, { Component } from "react";
import Layout from "./Components/Layout/Layout";
// import { VZThemeProvider } from "@vzrf/react-theme";

class App extends Component {
  render() {
    return (
        <Layout />
    );
  }
}

export default App;
